/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/itp-export/bytesToBase64.ts
 * FILE_ID: JOBHUB-QA-ITP-BYTES-001
 * PURPOSE: One base64 encoder for the signed PDF and the public signature.
 */
export function bytesToBase64(bytes: Uint8Array): string {
  let binary = ''
  for (let index = 0; index < bytes.length; index += 1) {
    binary += String.fromCharCode(bytes[index])
  }
  return btoa(binary)
}
